import Panel, { PanelBody } from '../../../components/Panel'
import TableSubcategories from './TableSubcategories'
import Initial from '../../../components/Initial'
import useInitial from '../useInitial'
import FilterSubcategories from './FilterSubcategories'
export default function Subcategories() {
    const state = useInitial()

    return (
        <Initial pageState={state}>
            <Panel>
                <PanelBody>
                    <FilterSubcategories />
                    <TableSubcategories />
                </PanelBody>
            </Panel>
        </Initial>
    )
}
